/**
 * Generate schema for Dexie.
 *
 * @param primaryKey - Primary key name or path for nested attribute.
 * @param additionalIndexes - Additional indexes.
 * @returns Schema.
 */
export function generateDexieSchema<T>(primaryKey: keyof T | string, additionalIndexes: (keyof T)[] = []): string {
  const indexesPart = additionalIndexes.length
    ? ', ' + additionalIndexes.map((prop) => prop.toString()).join(', ')
    : '';
  const schema = `${String(primaryKey)}${indexesPart}`;

  return `${String(primaryKey)}, ${String(schema)}`;
}

export enum TableNames {
  CURRENT_USER = 'current-user',
  DOCUMENT = 'document',
  DOCUMENT_TYPE = 'document-type',
  DATA_TYPE = 'data-type',
  EXTRACTION_RULE = 'extraction-rule',
  EXTRACTION_RUN = 'extraction-run',
}
